import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

import { VpTextLimit } from '..';
import { StyledBox } from './styles';

export const VpPromptAnswer = ({ prompt, mediaLabels }) => {
  return prompt?.mediaId || prompt?.attachmentId ? (
    <Chip label={`${mediaLabels[prompt?.mediaId || prompt?.attachmentId]}`} variant="colorTag" />
  ) : prompt?.isDeleted ? (
    <Chip label="Content Deleted" sx={{ margin: '0' }} />
  ) : prompt.isTermsAndConditionsSignature ? (
    <StyledBox component="img" src={prompt?.fileUrl} />
  ) : (
    <VpTextLimit value={prompt?.answer} limit={250} />
  );
};

VpPromptAnswer.propTypes = {
  prompt: PropTypes.object.isRequired,
  mediaLabels: PropTypes.object.isRequired
};

export default VpPromptAnswer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPromptAnswer/VpPromptAnswer.jsx